import { isFes } from "../../utils/diffentLayoutCheck";
const pageSize = Number(process.env.REACT_APP_PAGE_SIZE) || 30

const CounterBar = ({ articlesNumber, pageNumber,reset }) => {
  const firstNumber = pageNumber * pageSize + 1;
  const secondNumber =
    articlesNumber <= pageSize
      ? articlesNumber
      : (pageNumber + 1) * pageSize >= articlesNumber
      ? articlesNumber
      : (pageNumber + 1) * pageSize;
  return (
    <div className="w-full flex flex-row items-center px-5 lg:px-10 py-3 text-xs">
      {articlesNumber > 0 && (
        <div className={`w-full flex ${isFes() ? 'flex-row-reverse' : 'flex-row'} items-center justify-between`}>
          <span className="brand-font">
            SHOWING
            <span className="text-primary font-bold mx-1.5 brand-font underline">
              {firstNumber} - {secondNumber}
            </span>
            OUT OF{" "}
            <span className="text-primary font-bold brand-font underline">
              {articlesNumber}
            </span>{" "}
          </span>
          <div className="underline cursor-pointer hover:opacity-50" onClick={reset}>Reset filters</div>
        </div>
      )}
    </div>
  );
};
export default CounterBar;
